import { useEffect } from 'react';
import { dehydrate } from 'react-query/hydration';
import IndexDBStoreService from '../../services/IndexDBStoreService';
import { LOCALSTORAGELIST, CACHE } from '../constants/queryDefinition';

const usePersistQueryCache = queryClient => {
  useEffect(() => {
    async function deHydrateState() {
      const dehydratedState = dehydrate(queryClient, {
        shouldDehydrateQuery: query => {
          return LOCALSTORAGELIST.includes(query.queryKey as string);
        }
      });

      // Persist query cache in IndexDB storage for later hydration
      IndexDBStoreService.setItem(CACHE.query, dehydratedState);
    }

    window.addEventListener('beforeunload', deHydrateState);

    return () => window.removeEventListener('beforeunload', deHydrateState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePersistQueryCache;
